import PropTypes from 'prop-types';
import React from 'react';
import getImagePath from '../CommonUtils/getImagePath';
import {
  AnchorButton,
  Belt,
  Container,
  Intro,
  LinkButton,
  OptionText,
  SampleClient,
  Section,
  Text,
  Title,
} from './AdviserGetStartedStyles';
import { AddClientModal } from '../AddClientModal/AddClientModal';

class AdviserGetStartedView extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isAddClientModalOpen: false,
    };

    this.setIsAddClientModalOpen = this.setIsAddClientModalOpen.bind(this);
  }

  componentDidMount() {
    const { showStartPage, portalName } = this.props;

    document.title = `Welcome | ${portalName}`;

    this.helpKey = ADV.util.setHelp(ADV.HelpDescriptors.GetStarted);

    ADV.util.showAdviserAreaEmptyState(true);

    if (!showStartPage) {
      ADV.util.Router.go2('ClientSearch');
    }
  }

  componentWillUnmount() {
    ADV.util.unsetHelp(this.helpKey);
  }

  setIsAddClientModalOpen(isOpen) {
    this.setState({ isAddClientModalOpen: isOpen });
  }

  render() {
    const { user, endpoints, sampleClients, showFinancialPlanning } = this.props;
    const { isAddClientModalOpen } = this.state;

    return (
      <>
        <Container>
          <Intro>
            <Belt>
              <Title>Welcome to Orion Planning, {user.FirstName}!</Title>
              <Text>
                Orion Planning is an easy to use, cashflow-based financial planning application. Use
                it to create customized financial plans for all your clients, whether they are young
                or approaching retirement.
              </Text>

              <button type="button" onClick={() => this.setIsAddClientModalOpen(true)}>
                <i className="fa fa-user" />
                <i className="fa fa-plus" />
                Get started and add a client
              </button>

              {showFinancialPlanning && (
                <>
                  <OptionText>OR</OptionText>
                  <button
                    type="button"
                    onClick={() => {
                      ADV.util.Router.go2('AdviserSettings', {
                        page: 'Integrations',
                      });
                    }}
                  >
                    <i className="fa fa-cloud-download" /> Import your data
                  </button>
                </>
              )}
            </Belt>
          </Intro>
          <SampleClient>
            <Belt>
              <img alt="FinPlan Screenshot" src={getImagePath('finplan-screenshot.png')} />

              <Title>See a completed financial plan</Title>

              <Text>
                Walk through a sample completed Financial Plan and view the generated reports. Then,
                when you&apos;re ready,
                <LinkButton onClick={() => this.setIsAddClientModalOpen(true)}>
                  add your first client
                </LinkButton>
                .
              </Text>

              {sampleClients.map(sampleClient => (
                <>
                  <AnchorButton
                    href={`${endpoints.demo}&masterSampleClientId=${sampleClient.id}`}
                    rel="noopener noreferrer"
                    target="_blank"
                  >
                    View sample client {sampleClient.firstName} {sampleClient.lastName}
                    <i className="fa fa-external-link-alt" />
                  </AnchorButton>
                  <br />
                </>
              ))}
            </Belt>
          </SampleClient>
          <Section>
            <Title>Watch a demo video</Title>
            <iframe
              src="https://fast.wistia.net/embed/iframe/jk64zxkun8?seo=false"
              title="Orion Planning Overview Video"
              allow="autoplay; fullscreen"
              frameBorder="0"
              scrolling="no"
              className="wistia_embed"
              name="wistia_embed"
              width="900"
              height="506"
            />
          </Section>
        </Container>

        {isAddClientModalOpen && (
          <AddClientModal onClose={() => this.setIsAddClientModalOpen(false)} />
        )}
      </>
    );
  }
}

AdviserGetStartedView.propTypes = {
  sampleClients: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      firstName: PropTypes.string,
      lastName: PropTypes.string,
    }),
  ).isRequired,
  endpoints: PropTypes.shape({
    demo: PropTypes.string,
  }).isRequired,
  user: PropTypes.shape({
    FirstName: PropTypes.string,
  }).isRequired,
  showStartPage: PropTypes.bool.isRequired,
  portalName: PropTypes.string.isRequired,
  showFinancialPlanning: PropTypes.bool.isRequired,
};

export default AdviserGetStartedView;
